import React from "react";
import { Navigate, Route } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import LayoutIndexAdmin from "../layout-admin";
import LayoutIndex from "../layout";

const AuthProtected = (props) => {
  
    let currentUser;
    if (sessionStorage.getItem('authUser')) {
        currentUser = JSON.parse(sessionStorage.getItem('authUser'));
    } else if(sessionStorage.getItem('authAdmin')) {
        currentUser = JSON.parse(sessionStorage.getItem('authAdmin'));
    }

    if (currentUser) {
        if (jwtDecode(currentUser.token).exp > Date.now() / 1000) {
            if (
                currentUser.roles.includes('ADMIN')) {
                return <LayoutIndexAdmin>{props.children}</LayoutIndexAdmin>
            } else if(currentUser.roles.includes('MERCHANT') || currentUser.roles.includes('COLLABORATOR')) {
                return <LayoutIndex>{props.children}</LayoutIndex>
            } else {
                return <Navigate to={{ pathname: "/login-merchant", state: { from: props.location } }} />
            }
        } else {
            return <Navigate to={{ pathname: "/login-merchant", state: { from: props.location } }} />
        }
    } else {
        return <Navigate to={{ pathname: "/login-merchant", state: { from: props.location } }} />
    }
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        return (<> <Component {...props} /> </>);
      }}
    />
  );
};

export { AuthProtected, AccessRoute };